import i18next from "i18next";
import {initReactI18next} from "react-i18next";

const resources = {
    de: {
        translation: {
            common: {
                continue: 'Weiter',
                confirmString: 'bestätigen'
            },
            breeders: {
                filter: 'Züchter suchen',
                pickNewOwner: 'Neuen Besitzer für {{animal}} auswählen',
                enterExternal: 'Name des externen Züchters eingeben',
                notFound: 'Keine Züchter gefunden',
                ownerChangeConfirmTitle: 'Tierbesitz übertragen?',
                ownerChangeConfirmNotice: 'Diese Aktion kann nicht rückgängig gemacht werden!',
                ownerRequireConfirmString: 'Gib "{{confirmString}}" ein um das Tier an einen anderen Züchter übertragen zu können',
                ownershipTransferSuccess: 'Besitzer geändert'
            },
            treatmentType: {
                weighing: "Wiegung",
                othermedication: "Sonstige Medikation",
                other: "Sonstige Behandlung",
                spittest: "Spucktest",
                ultrasound: "Ultraschall",
                vaccination: "Impfung",
                bodyscore: "Bodyscore",
                vitaminsandminerals: "Vitamine und Mineralstoffe",
                antiparasitics: "Parasitenbehandlung"
            },
            herd: {
                filter: "Herde filtern"
            },
            gestation: {
                conflict: {
                    already_active: "Stute hat bereits eine aktive Trächtigkeit am {{date}}",
                },
            },
            breeder_create_success: "Konto erfolgreich angelegt",
            registered_at: "Registriert bei",
            breed: {
                HUACAYA: 'Huacaya',
                SURI: 'Suri',
            },
            sex: {
                MALE: 'männlich',
                FEMALE: 'weiblich',
                UNKNOWN: 'unbekannt',
            },
            color: {
                BAY_BLACK: 'Bay black',
                BEIGE: 'Beige',
                DARK_BROWN: 'Dark brown',
                DARK_FAWN: 'Dark fawn',
                DARK_ROSE_GREY: 'Dark rose grey',
                DARK_SILVER_GREY: 'Dark silver grey',
                LIGHT_BROWN: 'Light brown',
                LIGHT_FAWN: 'Light fawn',
                LIGHT_ROSE_GREY: 'Light rose grey',
                LIGHT_SILVER_GREY: 'Light silver grey',
                MEDIUM_BROWN: 'Medium brown',
                MEDIUM_FAWN: 'Medium fawn',
                MEDIUM_ROSE_GREY: 'Medium rose grey',
                MEDIUM_SILVER_GREY: 'Medium silver grey',
                MULTICOLOR: 'Multicolor',
                TRUE_BLACK: 'True black',
                UNKNOWN: 'Unbekannt',
                WHITE: 'Weiß',
                empty: 'keine',
            },
            eyecolor: {
                UNKNOWN: 'Keine Angabe',
                DARK: 'Dunkel',
                DARK_BROWN: 'Dunkelbraun',
                BLACK: 'Schwarz',
                BLUE: 'Blau',
                GREY: 'Grau',
            },
            identifier: {
                type: {
                    CHIP: 'Chip',
                    EAR_TAG: 'Ohrmarke',
                },
            },
            helpPage: {
                title: "Hilfeseite",
                searchLabel: "Hilfeartikel suchen",
                articleTitle: "{{title}}",
                articleSummary: "{{summary}}",
                readMore: "Weiterlesen",
                watchVideo: "Video ansehen",
                deleteTitle: "Hilfeartikel löschen",
                cancelButtonText: "Abbrechen",
                okButtonText: "Löschen",
                reachOut: "Deine Frage war nicht dabei? Dann sende uns eine"
            },
            helpArticleEditor: {
                editTitle: "Hilfeartikel bearbeiten",
                createTitle: "Neuen Hilfeartikel erstellen",
                titleLabel: "Titel",
                summaryLabel: "Zusammenfassung",
                fullUrlLabel: "Vollständige URL",
                videoUrlLabel: "Video-URL (optional)",
                saveButton: "Artikel speichern"
            },
            admin: {
                featureFlags: {
                    title: "Feature Flags",
                    filter: {
                        search: "Flags filtern",
                        type: "Typ",
                        allTypes: "Alle Typen",
                        overriddenOnly: "Nur überschrieben"
                    },
                    columns: {
                        key: "Flag",
                        type: "Typ",
                        defaultValue: "Standardwert",
                        currentValue: "Aktueller Wert",
                        value: "Wert",
                        overridden: "Überschrieben",
                        actions: "Aktionen"
                    },
                    status: {
                        overridden: "Überschrieben",
                        default: "Standard"
                    },
                    actions: {
                        edit: "Bearbeiten",
                        save: "Speichern",
                        cancel: "Abbrechen",
                        reset: "Auf Standard zurücksetzen"
                    },
                    edit: {
                        prompt: "{{type}}-Wert eingeben:"
                    },
                    tooltip: {
                        defaultValue: "{{value}}"
                    },
                    noFlagsFound: "Keine Feature Flags gefunden"
                }
            },
        },
    }
};

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: "de",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18next;
